export const groupConsultationDTOFields = {
    id: 'id',
    journalId: 'journalId',
    subject: 'subject',
    date: 'date',
    description: 'description',
    childrenWithParents: 'childrenWithParents',
} as const;
